import { List, styled } from '@mui/material';

const PREFIX = 'BottomMenuItemsSkeleton';

export const classes = {
  skeleton: `${PREFIX}-skeleton`,
};

export const StyledList = styled(List)(() => ({
  [`& .${classes.skeleton}`]: {
    backgroundColor: 'rgba(255,255,255, 25%)',
  },
}));